// Normalized API URL construction: SSR hits the local FastAPI origin + /api,
// the browser uses the same-origin /api. Trailing slashes are stripped so a
// custom NUXT_API_BASE never produces a double slash.
export function useApi() {
  const config = useRuntimeConfig()

  function join(base: string, path: string) {
    const b = (base || '').replace(/\/+$/, '')
    const p = path.startsWith('/') ? path : `/${path}`
    return `${b}${p}`
  }

  // SSR: e.g. http://127.0.0.1:8000 + /api ; client: /api
  const base = process.server
    ? join(config.apiBase as string, '/api')
    : (config.public.apiBase as string)

  function url(path: string) {
    return join(base, path)
  }

  function opts(extra: any = {}) {
    const headers = { ...(extra.headers || {}) }
    if (process.server) {
      const cookie = useRequestHeaders(['cookie']).cookie
      if (cookie) headers.cookie = cookie
    }
    return { credentials: 'include' as const, ...extra, headers }
  }

  return {
    url,
    get: <T>(path: string) => $fetch<T>(url(path), opts()),
    post: <T>(path: string, body?: any) => $fetch<T>(url(path), opts({ method: 'POST', body })),
    put: <T>(path: string, body?: any) => $fetch<T>(url(path), opts({ method: 'PUT', body })),
    del: <T>(path: string) => $fetch<T>(url(path), opts({ method: 'DELETE' })),
  }
}
